import React from 'react';

const CalendarHeaderMonth = ({ calendarDates, colSpan = 1, children = null }) => {
  const months = {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December',
  };

  function getCells() {
    const cells = [];
    const currentTd = { };
    let step = 1;
    calendarDates.forEach((calendarDate, i) => {
      const [day, numDate] = (calendarDate.label || '').split(' ');
      const date = calendarDate.stringISO;
      const monthNumber = date.match(/-(.+)-/)[1];
      const year = date.split('-')[0];
      if (currentTd.monthNumber === monthNumber) {
        if (day !== 'Mo') {
          currentTd.colSpan += parseInt(colSpan);
          step += 1;
        } else {
          cells.push({ ...currentTd });
          currentTd.year = year;
          currentTd.monthNumber = monthNumber;
          currentTd.colSpan = parseInt(colSpan);
          step = 1;
        }
      } else {
        if (i !== 0) { cells.push({ ...currentTd }); }
        currentTd.year = year;
        currentTd.monthNumber = monthNumber;
        currentTd.colSpan = parseInt(colSpan);
        step = 1;
      }
    });
    cells.push({ ...currentTd });
    return cells;
  }
  function renderCells(cells) {
    return cells.map((cell, i) => {
      return (
        <td key={ i } colSpan={ cell.colSpan }>
          { months[cell.monthNumber] } { cell.year }
        </td>
      );
    });
  }

  const tableCellsToDisplay = getCells();
  return (
    <tr className="row-month-label">
      {
        children
          ? <td>{ children }</td>
          : null
      }
      { renderCells(tableCellsToDisplay) }
    </tr>
  );
};

export default CalendarHeaderMonth;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/CalendarHeaderMonth.jsx